import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd2f021c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-mb-6 relative p-mt-6" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", {
  class: "date-range",
  style: {"top":"-3px","left":"10px"}
}, "search", -1))
const _hoisted_3 = { class: "p-d-flex p-ai-center p-flex-wrap p-ai-baseline p-justify-between" }
const _hoisted_4 = { class: "search-block" }
const _hoisted_5 = { class: "p-input-icon-left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "p-d-flex p-flex-column p-ml-3 relative"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "date-range" }, "date range", -1))
const _hoisted_9 = { class: "p-d-flex" }
const _hoisted_10 = { class: "calendar-block" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  width: "16",
  color: "#E0E0E0",
  style: {"height":"1px","margin-right":"9px","margin-left":"9px"}
}, null, -1))
const _hoisted_13 = { class: "calendar-block" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar" }, null, -1))
const _hoisted_15 = { class: "p-d-flex p-ai-center p-flex-wrap p-ml-4" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "p-d-flex align-items-center flex-column sm:flex-row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Chip = _resolveComponent("Chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_InputText, {
            class: "input-search",
            style: _normalizeStyle([ $props.range ? 'min-width: 30vw' : '']),
            type: "text",
            modelValue: $setup.searchValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchValue) = $event)),
            placeholder: $props.placeholder
          }, null, 8, ["style", "modelValue", "placeholder"])
        ])
      ]),
      ($props.range)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_Calendar, {
                  modelValue: $setup.startDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.startDate) = $event)),
                  class: "calendar",
                  placeholder: "Select start date"
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_Calendar, {
                  modelValue: $setup.endDate,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.endDate) = $event)),
                  class: "calendar",
                  placeholder: "Select end date"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("h6", {
          class: "clear-filters",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.clearFilters && $setup.clearFilters(...args)))
        }, "clear filters"),
        _createVNode(_component_Button, {
          label: "Search",
          class: "red-button p-col-2",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('searchValue', $setup.searchValue)))
        })
      ])
    ]),
    ($props.optionsName)
      ? (_openBlock(), _createElementBlock("h6", _hoisted_16, _toDisplayString($props.optionsName), 1))
      : _createCommentVNode("", true),
    ($props.options)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_Chip, {
            label: "All",
            icon: $setup.selectedAll ? 'pi pi-check' : '',
            style: {"color":"#E0010B"},
            class: _normalizeClass([[$setup.selectedAll ? 'selected' : ''], "mr-2 mb-2 custom-chip p-mr-4"]),
            onClick: $setup.selectAllPlatforms
          }, null, 8, ["icon", "class", "onClick"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (platform, index) => {
            return (_openBlock(), _createBlock(_component_Chip, {
              key: index,
              label: platform.value,
              icon: platform.selected ? 'pi pi-check' : '',
              onClick: [
                _withModifiers(($event: any) => {$setup.addPlatform(platform);}, ["prevent"]),
                $setup.sendName
              ],
              style: {"color":"#E0010B"},
              class: _normalizeClass(["mr-2 mb-2 custom-chip p-mr-4", [platform.selected ? 'selected' : '']])
            }, null, 8, ["label", "icon", "onClick", "class"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}